module.exports = __webpack_public_path__ + "static/img/pexels-andrea-piacquadio-3760069@2x.a9cce30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/productOperation/innovativeTechnology/pexels-andrea-piacquadio-3760069@2x.png
// module id = pI/5
// module chunks = 0